'use es6';

export function createAttribute(name) {
  return `data-base-ui-${name}`;
}